<template>
  <div class="w-100">
    <h5 class="text-center">Contenedores relacionados</h5>
    <div class="d-flex flex-column p-3">
      <div class="d-flex flex-row flex-wrap mb-2" v-for="(data, index) in dataResultadoContainers" :key="index">
        <h6 class="text-center text-danger">Bill of Lading No. {{ index }}</h6>
        <data-table
          :headers="headers"
          :data="data"
          :acciones="acciones"
          :idtabla="'containers_tabla_resultado' + index"
        />
      </div>
    </div>
  </div>
</template>

<script>
// Componentes
import DataTable from "../../../components/common/DataTable";
import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {
      headers: [
        "ID",
        "ID Bill Lading",
        "Número de contenedor",
        "Tipo de contenedor"
      ],
      acciones: [],
    };
  },
  components: {
    DataTable,
  },
  computed:{
    ...mapState("lineas", [
      "dataResultadoContainers",
    ]),
  },
  methods: {
    ...mapActions(["AccionCambiar", "ActionSetLoadingTable"]),
  },
};
</script>

<style>
.ui-modal--size-large > .ui-modal__wrapper > .ui-modal__container {
  width: 70rem;
}
</style>
